/* Mobile Devices */
export default () => ({
  isDragging: false,
  isPlaying: false,
  hasEnded: true,
  isLoading: true,
  isZoomed: false,
  isActive: true,
  dragDistance: 0,
  dragStartPos: 0,
  translate: 0,
  lineTranslate: 0,
  riderTranslate: 0,
  offset: 0,
  lastDrag: 0,
  speed: 30,
  playTick: null,
  halfOfScreen: window.innerWidth / 2,
  elementWidth: document.querySelector('.Timeline-line').offsetWidth,
  yearWidth: document.querySelector('.Timeline-year').offsetWidth,
  showOlderThan: 2006,
  lineWidth: 0,
  init() {
    this.$nextTick(() => {

      if (this.isMobile()) {
        const years = document.querySelectorAll('.Timeline-year');
        const timelineLine = document.querySelector('.Timeline-line');
        timelineLine.style.width = `${this.yearWidth * years.length}px`;
        this.elementWidth = document.querySelector('.Timeline-line').offsetWidth;
      }


      if (this.isMobile()) {
        this.translate = -this.elementWidth;
      } else {
        this.translate = this.elementWidth;
      }

      this.recalculate();
      this.checkShowMarkers();
    });

    window.onresize = this.recalculate.bind(this);
  },
  showTimeline() {
    this.isActive = true;
  },
  hideTimeline() {
    this.isActive = false;
  },
  recalculate() {
    const trp = (this.translate / this.elementWidth) * 100;

    this.halfOfScreen = window.innerWidth / 2;
    this.elementWidth = document.querySelector('.Timeline-line').offsetWidth;
    this.yearWidth = document.querySelector('.Timeline-year').offsetWidth;
    this.lineWidth = this.elementWidth;

    this.translate = (trp / 100) * this.elementWidth;

    this.checkShowMarkers();
  },
  dragStart(e) {
    if (!this.isDragging) {
      const clientX = e.clientX ? e.clientX : e.touches[0].clientX;
      this.lastDrag = clientX;

      if (!this.isMobile()) {
        if (
          !e.target.classList.contains('Timeline-button') &&
          !e.target.classList.contains('Timeline-playButton') &&
          !e.target.classList.contains('Timeline-playButtonComponent')
        ) {
          this.hasEnded = false;
          this.isDragging = true;
          this.translate =
            clientX - (window.innerWidth - this.elementWidth) / 2 - 55;
          this.checkShowMarkers();
        }
      } else if (
        !e.target.classList.contains('Timeline-button') &&
        !e.target.classList.contains('Timeline-playButton') &&
        !e.target.classList.contains('Timeline-playButtonComponent')
      ) {
        this.hasEnded = false;
        this.isDragging = true;
      }
    }
  },
  dragStop() {
    this.isDragging = false;
  },
  drag(e) {
    if (this.isDragging) {
      const clientX = e.clientX ? e.clientX : e.touches[0].clientX;
      if (this.isMobile()) {
        this.dragDistance = this.lastDrag - clientX;
        if (
          this.translate - this.dragDistance <= 0 &&
          this.translate - this.dragDistance >= -this.elementWidth
        ) {
          this.translate -= this.dragDistance;
          this.lastDrag = clientX;
        }

        this.checkShowMarkers();
      } else {
        this.dragDistance = this.lastDrag - clientX;
        if (this.translate > this.elementWidth) {
          this.translate = this.elementWidth;
        } else if (this.translate - this.dragDistance < 0) {
          this.translate = 0;
        } else if (this.translate >= 0) {
          this.translate =
            clientX - (window.innerWidth - this.elementWidth) / 2 - 55;
          this.lastDrag = clientX;
        }

        this.checkShowMarkers();
      }
    }
  },
  playPause() {
    if (!this.isPlaying) {
      this.play();
      this.isPlaying = true;
    } else {
      this.stop();
      this.isPlaying = false;
    }
  },
  play() {
    if (this.isZoomed) {
      this.$dispatch('navigate', '/');
    }

    if (this.hasEnded) {
      this.$store.global.skipAnimation = true;
      this.translate = 0;
      this.hasEnded = false;
    }

    this.playTick = setInterval(() => {
      if (this.isMobile()) {
        this.translate -= this.elementWidth / 800;
      } else {
        this.translate += this.elementWidth / 800;
      }
      this.checkShowMarkers();

      if (
        this.translate <= -this.elementWidth ||
        this.translate > this.elementWidth
      ) {
        this.stop();
        this.isPlaying = false;
        this.hasEnded = true;
      }
    }, this.speed);
  },
  stop() {
    clearInterval(this.playTick);
  },
  checkShowMarkers() {
    if (this.isMobile()) {
      this.riderTranslate = 0;
      this.lineTranslate = this.translate;

      const mod = this.translate / 50;
      this.showOlderThan = 2007 - mod - 1;
    } else {
      this.riderTranslate = this.translate;
      this.lineTranslate = 0;

      const mod = Math.floor(this.translate / this.yearWidth);
      this.showOlderThan = 2006 + mod;
    }

    this.$store.global.showYear = this.showOlderThan;

    this.$dispatch('show-hide-markers', this.showOlderThan);
  },
  getLineTranslate() {
    return this.isMobile ? `translateX(${this.translate}px)` : 0;
  },
  getRiderTranslate() {
    return !this.isMobile ? `translateX(${this.translate}px)` : 0;
  },
  isMobile() {
    return window.innerWidth < 768;
  },
  mapLoaded() {
    this.isLoading = false;
  },
  zoomIn() {
    this.isZoomed = true;
    this.stop();
    this.isPlaying = false;
  },
  zoomOut() {
    this.isZoomed = false;
  }
});
